export default __webpack_public_path__ + "static/media/companyimg.582c3406.jpg";